module.exports = __webpack_public_path__ + "img/21-small.1cdd920a.png";